export const breadcrumbMap: Record<string, string> = {
  login: 'Đăng nhập',
  'svg-viewer': 'Danh sách svg icon',
  'phan-quyen': 'Quản lý nhóm quyền',
  'quan-ly-nguoi-dung': 'Danh bạ nhân viên',
  'tham-so-he-thong': 'Quản lý SystemKey',
  'chu-van-bang-thieu-lien-he': 'Chủ tài liệu chưa có liên hệ',
  'tai-khoan-cong-dan': 'Tài khoản công dân',
  'tai-khoan-dai-dien': 'Tài khoản đại diện',
  'phat-hanh': 'Phát hành và sinh mã',
  'hang-cho-ky': 'Văn bản chờ ký',
  'thong-ke-ky': 'Thống kê ký',
  'van-bang': 'Quản lý tài liệu',
  'kho-van-bang': 'Quản lý tài liệu',
  'gui-van-ban': 'Gửi văn bản',
  'tra-cuu': 'Tra cứu và xác thực tài liệu',
  'nhat-ky-he-thong': 'Nhật ký hệ thống',
  'giam-sat-van-hanh': 'Giám sát vận hành',
  'bao-cao': 'Báo cáo và thống kê',
  'bang-dieu-khien': 'Bảng điều khiển điều hành',
  'chuc-vu': 'Quản lý chức vụ',
  'loai-tai-lieu': 'Loại tài liệu',
  'luong-ky': 'Luồng ký',
  'import-tai-lieu': 'Import tài liệu',
  'van-ban-da-ky': 'Văn bản đã ký',
  'ho-so-da-ky': 'Văn bản đã ký',
}
